import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';
import {awsConfig} from '../../shared/config';

import {addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';


const corCodesLoading = () => ({
    type: ActionTypes.COR_CODES_LOADING
});

const corCodesFailed = (errmess) => ({
    type: ActionTypes.COR_CODES_FAILED,
    payload: errmess
});

const addCorCodes = (codes) => ({
    type: ActionTypes.ADD_COR_CODES,
    payload: codes
});


/**
 * Fetch all the COR codes.
 * If clientId is null, bring all users
 * 
 * @returns 
 */
export const fetchCorCodes = () => (dispatch) => {

    const url =  new URL(`${awsConfig.api.invokeUrl}${RestURI.COR_CODES}`);
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(corCodesLoading({}));

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(codes => dispatch(addCorCodes(codes)))
        .catch(error => {
            dispatch(corCodesFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii codurilor COR" } }));
        });
}